import { render } from "./BillingAccountDetail.vue?vue&type=template&id=1bcd851f&scoped=true"
import script from "./BillingAccountDetail.vue?vue&type=script&lang=js"
export * from "./BillingAccountDetail.vue?vue&type=script&lang=js"

import "./BillingAccountDetail.vue?vue&type=style&index=0&id=1bcd851f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcd851f"]])

export default __exports__